import axios from 'axios';

// Get the API URL from environment variables or use a default
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create axios instance with the base URL
const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // This is key for sending cookies cross-origin
});

export default api;